module.exports = __webpack_public_path__ + "img/select.8623747a.svg";